v<template>
	<div class="product">
		<div class="search-order">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="24">
					<el-col :span="24">
						<div class="el-right">
							<el-form
								ref="order"
								:model="search"
								:inline="true"
								label-width="10px"
								size="small"
								class="demo-form-inline el-input-height"
							>
								<el-form-item prop="userName">
									<el-input
										v-model="search.userName"
										:placeholder="$t('user.userName')"
									></el-input>
								</el-form-item>
								<el-form-item prop="nickName">
									<el-input
										v-model="search.nickName"
										:placeholder="$t('user.nickName')"
									></el-input>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="onSubmit"
										icon="el-icon-search"
										>{{ $t("common.search") }}</el-button
									>
									<el-button @click="resetSearch()" icon="el-icon-refresh">{{
										$t("common.reset")
									}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="accountList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="userName"
					:label="$t('user.userName')"
					width="200"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="nickName"
					:label="$t('user.nickName')"
					width="200"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="price"
					:show-overflow-tooltip="true"
					:label="$t('user.userWallet')"
					:align="'center'"
					:formatter="userWalletMatter"
				></el-table-column>
				<el-table-column
					prop="freezePrice"
					:show-overflow-tooltip="true"
					:label="$t('user.userFrozenWallet')"
					:align="'center'"
					:formatter="userFrozenWalletMatter"
				></el-table-column>

				<el-table-column
					prop="owePrice"
					:show-overflow-tooltip="true"
					:label="$t('user.userUnpaidWallet')"
					:align="'center'"
					:formatter="userUnpaidWalletMatter"
				></el-table-column>
				<el-table-column
					prop="allPrice"
					:show-overflow-tooltip="true"
					:label="$t('user.rechargeTotal')"
					:align="'center'"
					:formatter="rechargeTotalMatter"
				></el-table-column>
				<el-table-column
					prop="consumptionAmount"
					:show-overflow-tooltip="true"
					:label="$t('user.consumptionAmount')"
					:align="'center'"
					:formatter="consumptionAmountMatter"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="page.totalSize > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "Record",
	components: {},
	data() {
		return {
			dateTime: "",
			search: {
				userName: "",
				nickName: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			accountList: [],
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		// 格式化金额
		userWalletMatter(row) {
			let realVal = "";
			if (row.price) {
				realVal = "$" + parseFloat(row.price).toFixed(2);
			}
			return realVal;
		},
		userFrozenWalletMatter(row) {
			let realVal = "";
			if (row.freezePrice) {
				realVal = "$" + parseFloat(row.freezePrice).toFixed(2);
			}
			return realVal;
		},

		userUnpaidWalletMatter(row) {
			let realVal = "";
			if (row.owePrice) {
				realVal = "$" + parseFloat(row.owePrice).toFixed(2);
			}
			return realVal;
		},
		rechargeTotalMatter(row) {
			let realVal = "";
			if (row.allPrice) {
				realVal = "$" + parseFloat(row.allPrice).toFixed(2);
			}
			return realVal;
		},
		consumptionAmountMatter(row) {
			let realVal = "";
			if (row.consumptionAmount) {
				realVal = "$" + parseFloat(row.consumptionAmount).toFixed(2);
			}
			return realVal;
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		// 加载流水列表
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.myWallet.moneyPage, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.accountList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 提交查询搜索
		onSubmit() {
			this.page.pageIndex = 1;
			this.currentChange();
		},
		// 重置条件
		resetSearch() {
			this.search.userName = "";
			this.search.nickName = "";
			this.currentChange();
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>
